import { Brand, Env } from '..'
import { getAuth0Feature } from '../../core/pure/Window'
import { getAuthToken, getAuthTokenOnTest } from './getAuthToken'
import { getCiamAccessToken } from './getCiamToken'

// Authorization call for getting the token
export const getTokenApiUrl = (env: Env | undefined, brand: string): string => {
  switch (env) {
    case 'test':
    case 'preview':
    case 'production':
      return `${window.location.origin}/token`
    default:
      return `https://testauth.${brand}.be/OIDC/Login`
  }
}

export const mapDomain = (brand: Brand): string => {
  switch (brand) {
    case 'dl':
      return 'limburger.nl'
    case 'ds':
      return 'standaard.be'
    case 'gva':
      return 'gva.be'
    case 'hbvl':
      return 'hbvl.be'
    case 'nb':
    default:
      return 'nieuwsblad.be'
  }
}

export const tokenApiBaseUrl = getTokenApiUrl(MH_ENV, mapDomain(MH_BRAND))

export const callAuthToken = async (): Promise<string> => {
  if (MH_ENV !== 'develop') {
    if (getAuth0Feature()) return getCiamAccessToken()
    return (await getAuthToken()).access_token
  }

  return (await getAuthTokenOnTest()).accessToken
}
